import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import axios from 'axios';
import { getToken } from '../firebase';

const PaymentSuccess = (user) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);
  const sessionId = searchParams.get('session_id');
  const workgroupId = searchParams.get('workgroupId');
  const paymentType = searchParams.get('payment_type');

  useEffect(() => {
    const handlePaymentSuccess = async () => {
      try {
        if (!sessionId) {
          throw new Error('No session ID found');
        }
        if (!workgroupId) {
          throw new Error('No workgroup ID found');
        }
        if (!paymentType) {
          throw new Error('No payment type found');
        }

        const response = await axios.post(
          `${location.protocol}//${location.hostname}/api/server/payment-success`,
          { session_id: sessionId, workgroupId: workgroupId, payment_type: paymentType },
          {
            headers: {
              'Authorization': `Bearer ${await getToken()}`
            }
          }
        );
      } catch (err) {
        console.error('Error processing payment success:', err);
        setError(err.message);
      }
    };

    handlePaymentSuccess();
  }, [sessionId, workgroupId, paymentType]);

  const getSuccessMessage = () => {
    switch (paymentType) {
      case 'credit':
        return 'Thank you for adding credit to your account. Your balance has been updated.';
      case 'per_seat':
        return 'Thank you for upgrading to per-seat pricing. Your subscription has been activated.';
      default:
        return 'Thank you for your payment. Your license has been updated.';
    }
  };

  if (error) {
    return (
      <div className="min-h-full h-full flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="max-w-md w-full space-y-8 p-8 bg-white dark:bg-gray-800 rounded-lg shadow-lg">
          <div className="text-center">
            <div className="text-red-500 text-2xl mb-4">⚠️</div>
            <h2 className="text-3xl font-bold text-gray-900 dark:text-white">
              Error Processing Payment
            </h2>
            <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
              {error}
            </p>
            <button
              onClick={() => navigate('/admin')}
              className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              Return to Admin Page
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-full h-full flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="max-w-md w-full space-y-8 p-8 bg-white dark:bg-gray-800 rounded-lg shadow-lg">
        <div className="text-center">
          <CheckCircle2 className="mx-auto h-16 w-16 text-green-500" />
          <h2 className="mt-6 text-3xl font-bold text-gray-900 dark:text-white">
            Payment Successful!
          </h2>
          <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
            {getSuccessMessage()}
          </p>
          <button
            onClick={() => navigate('/admin')}
            className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            Return to Admin Page
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess; 
